<template>
    <div class="grid">
        <template v-for="(article, index) in relatedArticles" :key="article.id">
            <AdComponent v-if="index % 6 === 0"/>
            <div class="col-12 lg:col-4 md:col-6">
                <Article
                    :article="article"
                    :newspaper="article.newspaper"
                    class="col-xl-4 col-md-6 pb-4"/>
            </div>

        </template>
    </div>
</template>
<script>

import AdComponent from '@/Components/AdComponent.vue'
import Article from '@/Components/NewsPortal/Article.vue'

export default {
    components: { Article, AdComponent },
    props     : {
        articles: Array
    },
    computed  : {
        relatedArticles () {
            if (this.articles.length % 2 !== 0) {
                this.articles.pop()
            }

            return this.articles
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
